<template>
    <div ref="loading" class="relative transition-all ease-in-out duration-200 h-max-content">
        <slot></slot>
        <div
            v-if="loading"
            class="backdrop-blur flex items-center justify-center z-30"
            :class="[inset ? '-top-2 -bottom-2 -left-2 -right-2' : 'top-0 bottom-0 left-0 right-0', stickyLoader ? 'fixed top-[50%]' : 'absolute']"
        >
            <div class="flex flex-col items-center">
                <FontAwesomeIcon v-show="loading" :icon="['fas', 'circle-notch']" class="animate-spin transition-all ease-in-out duration-300 text-lg" :class="spinnerClass">
                </FontAwesomeIcon>
                <p v-if="text" class="text text-center mt-2">
                    {{ text }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        loading: Boolean,
        text: String,
        inset: Boolean,
        containerClass: String,
        spinnerClass: String,
        stickyLoader: false
    }
};
</script>
